export enum PostingType {
    PUBLIC = "PUBLIC",
    PRIVATE = "PRIVATE"
}

export enum PostingSource {
    AFRIAUTOS = "AFRIAUTOS",
    WHATSAPP = "WHATSAPP",
    FACEBOOK = "FACEBOOK",
    LINKEDIN = "LINKEDIN",
    INSTAGRAM = "INSTAGRAM",
    TELEGRAM = "TELEGRAM",
    OTHER = "OTHER"
}

export enum PostingStatus {
    CREATED = "CREATED",
    PENDING = "PENDING",
    POSTED = "POSTED",
    CANCELLED = "CANCELLED"
}

export enum PostingAction {
  CREATE = "CREATE",
  CANCEL = "CANCEL",
  EDIT = "EDIT",
  REOPEN = "REOPEN",
  ACCEPT = "ACCEPT"
}

export interface PostingActionItem {
  action: PostingAction,
  title: string,
  icon?: string
};


export class PostingBasicData{
    public static postingActionItems : PostingActionItem[] = [
      {
        action: PostingAction.CREATE,
        title: "Créer",
        icon: 'add'
      },
      {
        action: PostingAction.ACCEPT,
        title: "Accepter",
        icon: 'accept'
      },
 
      {
        action: PostingAction.CANCEL,
        title: "Annuler",
        icon: 'cancel'
      },
      {
        action: PostingAction.EDIT,
        title: "Editer",
        icon: 'edit'
      },
      {
        action: PostingAction.REOPEN,
        title: "Réouvrir",
        icon: 'open'
      }
  ];
}